import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Add to List v1 Configuration Validator
 * Validates HubSpot list membership addition with contact identification
 */
export const Hubspot_Add_To_List_1_ConfigValidator = z
    .object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    listId: requiredString('List ID is required'),
    contactId: z.string().optional(),
    contactPhoneNumber: z.string().optional()
})
    .refine((data) => {
    const hasContactId = data.contactId && data.contactId.trim() !== '';
    const hasContactPhone = data.contactPhoneNumber && data.contactPhoneNumber.trim() !== '';
    return (hasContactId || hasContactPhone) && !(hasContactId && hasContactPhone);
}, {
    path: ['contact'],
    message: 'Please fill in either Contact ID or Contact Phone Number'
});
//# sourceMappingURL=hubspot-add-to-list-1.js.map